var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 3a.7.7 0 0 1 .7-.7h18a.7.7 0 0 1 .7.7v10.286a.7.7 0 0 1-.205.495l-3.857 3.857a.7.7 0 0 1-.495.205h-6.17L6.67 21.532A.7.7 0 0 1 5.514 21v-3.157H3a.7.7 0 0 1-.7-.7V3Zm1.4.7v12.743h2.514a.7.7 0 0 1 .7.7v2.335l3.345-2.867a.7.7 0 0 1 .455-.168h6.139l3.447-3.447V3.7H3.7Zm7.6 8.943V6.214h1.4v6.429h-1.4Zm3.857 0V6.214h1.4v6.429h-1.4Z",
    fill: "currentColor"
  })));
};
export { SvgTwitch as ReactComponent };
export default __webpack_public_path__ + "d8a7e8fef5f64fe94bed3cb0875b1e2e.svg";